<template>
    <div class="create-table">
        <!-- Şablonlar bölümü (ana CTA) -->
        <div class="templates-panel" @click="goToTemplates">
            <div class="panel-header">
                <div class="panel-icon">
                    <i class="material-icons">dashboard_customize</i>
                </div>
                <div class="panel-title-wrap">
                    <div class="panel-title">{{ $t("tables.templates.sidebarTitle") }}</div>
                    <div class="panel-subtitle">{{ $t("tables.templates.linkSubtitle") }}</div>
                </div>
                <i class="material-icons panel-arrow">arrow_forward</i>
            </div>

            <div class="sector-chips">
                <div
                    v-for="s in sectors"
                    :key="s.key"
                    class="sector-chip"
                    :style="{ background: s.bg, color: s.color }"
                >
                    <i class="material-icons">{{ s.icon }}</i>
                    <span>{{ sectorLabel(s.key) }}</span>
                </div>
            </div>
        </div>

        <!-- Ayırıcı -->
        <div class="divider">
            <span class="divider-line"></span>
            <span class="divider-text">{{ $t("tables.templates.or") }}</span>
            <span class="divider-line"></span>
        </div>

        <!-- Boş Tablo Oluştur bölümü -->
        <div class="blank-section">
            <h4 class="blank-title">
                <i class="material-icons">add_box</i>
                {{ $t("tables.templates.blankTableSectionTitle") }}
            </h4>

            <a-form :model="table" layout="vertical" class="blank-form">
                <a-form-item :label="$t('tables.tableName')">
                    <a-input v-model:value="table.name" :placeholder="$t('tables.tableName')" />
                </a-form-item>
                <a-form-item :label="$t('tables.description')">
                    <a-textarea v-model:value="table.description" :rows="2" />
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" @click="createTable" :disabled="!table.name">
                        {{ $t("tables.createTable") }}
                    </a-button>
                </a-form-item>
            </a-form>
        </div>
    </div>
</template>

<script>
const SECTORS = [
    { key: "personel",   icon: "groups",                bg: "#e6f4ff", color: "#1890ff" },
    { key: "teknoloji",  icon: "memory",                bg: "#f3e8ff", color: "#7c3aed" },
    { key: "finans",     icon: "account_balance",       bg: "#dcfce7", color: "#16a34a" },
    { key: "saglik",     icon: "local_hospital",        bg: "#fee2e2", color: "#dc2626" },
    { key: "egitim",     icon: "school",                bg: "#fef3c7", color: "#d97706" },
    { key: "sigorta",    icon: "verified_user",         bg: "#ccfbf1", color: "#0d9488" },
    { key: "eticaret",   icon: "shopping_cart",         bg: "#fef9c3", color: "#ca8a04" },
    { key: "perakende",  icon: "storefront",            bg: "#cffafe", color: "#0891b2" },
    { key: "uretim",     icon: "factory",               bg: "#e5e7eb", color: "#4b5563" },
    { key: "yapi",       icon: "construction",          bg: "#fed7aa", color: "#c2410c" },
    { key: "market",     icon: "local_grocery_store",   bg: "#d9f99d", color: "#65a30d" },
    { key: "yiyecek",    icon: "restaurant",            bg: "#ffedd5", color: "#ea580c" },
    { key: "pazarlama",  icon: "campaign",              bg: "#fce7f3", color: "#db2777" },
    { key: "lojistik",   icon: "local_shipping",        bg: "#e0e7ff", color: "#4338ca" },
];

export default {
    name: "CreateTable",
    data() {
        return {
            table: { name: "", description: "" },
            sectors: SECTORS,
        };
    },
    methods: {
        createTable() {
            if (!this.table.name) return;
            this.$emit("create", this.table);
        },
        goToTemplates() {
            this.$emit("navigate-to-templates");
        },
        sectorLabel(key) {
            const i18nKey = `tables.templates.sectors.${key}`;
            const translated = this.$t(i18nKey);
            return translated === i18nKey ? key : translated;
        },
    },
};
</script>

<style scoped lang="scss">
.create-table {
    display: flex;
    flex-direction: column;
    gap: 16px;

    // ───────────────────────────── Şablonlar paneli (CTA) ─────────────────────────────
    .templates-panel {
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 14px;
        padding: 16px 18px;
        border: 1px solid #d6e8ff;
        border-radius: 10px;
        background: linear-gradient(135deg, #f5faff 0%, #ffffff 100%);
        cursor: pointer;
        transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;

        &::before {
            content: "";
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            width: 4px;
            background: #1890ff;
            border-radius: 10px 0 0 10px;
        }

        &:hover {
            border-color: #1890ff;
            box-shadow: 0 4px 14px rgba(24, 144, 255, 0.12);
            transform: translateY(-1px);
        }

        .panel-header {
            display: flex;
            align-items: center;
            gap: 12px;

            .panel-icon {
                width: 40px;
                height: 40px;
                border-radius: 10px;
                background: #1890ff;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-shrink: 0;

                .material-icons {
                    color: #ffffff;
                    font-size: 22px;
                }
            }

            .panel-title-wrap {
                flex: 1;
                display: flex;
                flex-direction: column;
                gap: 2px;

                .panel-title {
                    font-size: 16px;
                    font-weight: 700;
                    color: #1f2937;
                }

                .panel-subtitle {
                    font-size: 12px;
                    color: #6b7280;
                }
            }

            .panel-arrow {
                font-size: 22px;
                color: #1890ff;
                transition: transform 0.15s ease;
            }
        }

        &:hover .panel-arrow {
            transform: translateX(3px);
        }

        .sector-chips {
            display: flex;
            gap: 6px;
            flex-wrap: wrap;

            .sector-chip {
                display: inline-flex;
                align-items: center;
                gap: 5px;
                padding: 4px 10px;
                border-radius: 14px;
                font-size: 12px;
                font-weight: 500;

                .material-icons {
                    font-size: 14px;
                }
            }
        }
    }

    // ───────────────────────────── Ayırıcı (veya) ─────────────────────────────
    .divider {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 2px 0;

        .divider-line {
            flex: 1;
            height: 1px;
            background: #e5e7eb;
        }

        .divider-text {
            font-size: 11px;
            color: #9ca3af;
            text-transform: lowercase;
            letter-spacing: 0.5px;
        }
    }

    // ───────────────────────────── Boş Tablo bölümü ─────────────────────────────
    .blank-section {
        display: flex;
        flex-direction: column;
        gap: 6px;

        .blank-title {
            display: flex;
            align-items: center;
            gap: 6px;
            font-size: 14px;
            font-weight: 600;
            color: #374151;
            margin: 0 0 6px;

            .material-icons {
                font-size: 18px;
                color: #6b7280;
            }
        }

        .blank-form {
            padding: 0;
        }
    }
}
</style>
